import isEmpty from 'lodash/isEmpty';
import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

const MY_ALERTS_URL_PATH = '/browse-aggregator/v1/myalert-subscription';
const defaults = {
    featureFlags: {},
};

export const signupForAlerts = ({ payload }) => { //eslint-disable-line
    let errors = '';
    const featureFlags = payload.featureFlags || defaults.featureFlags;
    const requiredPayloadProps = ['email', 'sku', 'link'];

    if (featureFlags.sendMyAlertsSource) {
        requiredPayloadProps.push('source');
    }
    const context = RestClient.getContext();

    let requestParams = {
        notifications: {
            email: true,
            sms: false,
            push: false,
        },
        watch: {
            availability: true,
            price: false,
            gone: true,
        },
    };

    requiredPayloadProps.forEach((prop) => {
        if (!Object.prototype.hasOwnProperty.call(payload, prop)) {
            const message = `${prop} is not passed`;
            console.error(message);
            errors = errors.concat(' ', message);
        } else if (prop === 'sku') {
            requestParams = { ...requestParams, matching: { [prop]: payload[prop] } };
        } else {
            requestParams = { ...requestParams, [prop]: payload[prop] };
        }
    });

    if (!isEmpty(errors)) {
        return new Promise((resolve, reject) => {
            reject({ error: true, message: errors });
        });
    }

    return RestClient.post({
        url: MY_ALERTS_URL_PATH,
        customHeaders: {
            'Content-Type': 'application/json',
        },
        apiHost: apiHosts.browse,
        params: requestParams,
        excludeVersion: true,
        hostname: context && context.hostname,
    }).then((json) => json.data);
};
